import {
  MDBAlert,
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getPhoneNumsByType } from "../../apiclients/streamsapi_bridge";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import DeletePhoneNumber from "../../views/popups/phonenumbers/DeletePHNumbers";
import EditValidatedPHnum from "../../views/popups/phonenumbers/EditValidatedPHnum";
import PopupLoader from "../../views/popups/PopupLoader";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";

export default function ValidatePhoneNumbers(props) {
  const [assignNumbers, setAssignedNumbers] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [unassignPHNum, SetUnassignPHNum] = useState(false);
  const [selectedPHNum, setSelectedPHNum] = useState(null);
  const [selectedAliasname, setSelectedAliasname] = useState([]);
  const [editFlag, setEditFlag] = useState(false);
  const editToggle = () => setEditFlag(!editFlag);
  const [rerender, setrerender] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [validPhNumDetails, setValidPhNumDetails] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const utogglePopup = () => SetUnassignPHNum(!unassignPHNum);
  const editValidateNumRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)

  function handleClick() {
    editValidateNumRef.current.click();
  }

  function showThisInf(tdata) {
    navigate("/phonenumberdetails", {
      state: tdata.phnumInfo,
    });

  }

  function editAliaseInfo(info) {
    setSelectedPHNum(info.phnumber);
    setSelectedAliasname(info.assignedname);
    setEditFlag(true);

  }

  function unassignPhoneNumber(evntData, phno) {
    evntData.preventDefault();
    evntData.stopPropagation();
    let selPhone = assignNumbers.filter((tmdata) => tmdata.phnumber == phno).map((tmdata) => tmdata.phnumber);;
    SetUnassignPHNum(true);
    setSelectedPHNum(selPhone);
  }



  async function fetchData() {
    sessionStorage.setItem("current_link", "phonenumbers");
    console.log(sessionStorage.getItem("admin_session"));
    setIsloading(true);
    const response = await getPhoneNumsByType(3, JSON.parse(sessionStorage.getItem("admin_session")).siteid, TabIDConstant.VALIDATED_PH_NUM_SUBLINK);
    // setTimeout(() => {
      setIsloading(false);
    // }, 1000);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    console.log(`Response: ${JSON.stringify(rawData)}`);
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + rawData);
    setAssignedNumbers(rawData?.ph_numbers?.validated_phnum ?? []);
    
  }

  const [isEditing, setIsEditing] = useState(null);
  const [locationName, setLocationName] = useState();

  const handleEditClick = (e, aliasName) => {
    e.stopPropagation();
    e.preventDefault();
    setIsEditing(aliasName);
  };

  const handleInputChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setLocationName(e.target.value);
  };

  useEffect(()=>{
  let processdrows = [];
  assignNumbers.map((phnum) => {
    let phNumber = phnum.phnumber ? formattedNumber(phnum.phnumber) + "" : ""
    processdrows.push({
      phnumInfo: phnum,
      phnumber: phNumber,
      actualNumber: phNumber?.toString().replace(/[ ]/g, ''),
      state: phnum.state + "",
      assignedto: phnum.assignedto + "",
      assignedname: phnum.alias_name ?? '',
      number: phnum.phnumber + "" ?? "",

      // assignedname: (<>{ (phnum.alias_name != '' && isEditing == phnum.alias_name) ? (
      // <input
      //   type="text"
      //   value={isEditing}
      //   onChange={handleInputChange}
      // />) : (<span>{phnum.alias_name}</span>)}</>),

      location_name: phnum?.location_name ? phnum?.location_name : "",
      unassign: (
        <>

          {/* <a className="ms-4"
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => unassignPhoneNumber(e, `${phnum.phnumber}`)}
            target="_new"
          >
            <MDBIcon fas icon="times" color="primary" title="Unassign" />
          </a> */}

          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => unassignPhoneNumber(e, `${phnum.phnumber}`)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      ),

      // unassign: (<>
      // {/*<a className="ms-4"
      //     style={{ zIndex: 99996 }}
      //     href="#"
      //     onClick={(e) =>unassignPhoneNumber(e, `${phnum.phnumber}`)}
      //     target="_new"
      //   ><MDBIcon fas icon="times" className="green" title="Unassign" /></a>*/}
      //   <div className="d-flex align-items-center ">
      //     <div className="custom-hover-bg p-1 cursor-pointer AddToolTip" onClick={ (e)=> handleEditClick(e, phnum.alias_name)}>
      //       <MDBIcon className="fs-5" far icon="edit" color="primary" />
      //     </div>
      //     <div className="custom-hover-bg ms-3 p-1 px-2 cursor-pointer deleteToolTip" onClick={(e) => unassignPhoneNumber(e, `${phnum.phnumber}`)}>
      //       <MDBIcon className="fs-5" fas icon="times" color="primary" />
      //     </div>
      //   </div>
      // </>
      // ),

    })
  })
  setFilteredRows(processdrows);
  setValidPhNumDetails(processdrows)
  setDataLoaded(true)
  },[assignNumbers])


  const basicData = {
    columns: [
      { label: "Phone Number(s)", field: "phnumber", sort: true },
      { label: "Alias Name ", field: "assignedname" },
      { label: "Remove ", field: "unassign", sort: false },
    ],
    rows: validPhNumDetails,
  };
   const handleManualSearch = (searchValue) =>{
    setSearchValue(searchValue); 
    const filtered = customSearch(validPhNumDetails, searchValue, UIConstant.VALIDATE_PHONE_NUMBERS);
  
    setFilteredRows(filtered);
  };
  // Fetching the data for display
  useEffect(() => {
    if (props.isActive || rerender) {
      fetchData();
      setrerender(false);
    }
  }, [props.isActive, rerender]);

  return (
    <>
      {/* {isloading && (
          <>
            <div className="loadingclass">
              <MDBSpinner className="ms-2" color="primary">
                <span className="visually-hidden">Loading...</span>
              </MDBSpinner>
            </div>
          </>
  
        )} */}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {/* <p className="mb-2">
          <strong>{t('Note')}: </strong>
          {t('assignNote')}
        </p> */}
      <div className="w-100 phonenumbersDatatable">
        <div class="actionbar"></div>
        <div className='mb-2 mt-0 position-relative w-auto'>
                        <MDBInput
                          label="Search"
                          ref={searchRef}
                          value={searchValue}
                          onChange={(e) => handleManualSearch(e.target.value)}
                        />
                        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                      </div>
        <MDBDatatable className="actioncolumn"
          onRowClick={(event) => {
            editAliaseInfo(event);
          }}
           key={searchValue}
          // search
          fixedHeader
          entries={50}
          maxHeight="63vh"
          // multi
          // selectable
          sortField="Phone Number(s)"
          sortOrder="asc"
          searchInputProps={[]}
          data={{...basicData,rows:filteredRows}}
          responsive
          hover
        />
      </div>
      {unassignPHNum && (
        <PopupLoaderNew
          title={"Remove Phone Number"}
          content={<DeletePhoneNumber
            phoneNum={selectedPHNum}
            onClose={utogglePopup}
            ref={editValidateNumRef}
            setIsloading={setisLoading}
          />}
          onShow={SetUnassignPHNum}
          onClose={utogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}

      {editFlag && (
        <PopupLoaderNew
          title={"Edit Validated Number"}
          content={<EditValidatedPHnum
            phoneNum={selectedPHNum}
            alias_name={selectedAliasname}
            onClose={editToggle}
            ref={editValidateNumRef}
            setIsloading={setisLoading}
            setrerender={setrerender}
            setSuccessMessage={props.setSuccessMessage}
          />}
          onShow={setEditFlag}
          onClose={editToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={2}
        />


      )}
      {(props.successMessage) && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={8000}
          onClose={() => props.setSuccessMessage("")}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{props.successMessage}</span>
        </MDBAlert>
      )}
      <Tooltip anchorSelect=".AddToolTip" place="top" className="exampleTooltip">Edit</Tooltip>
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">Remove</Tooltip>
    </>
  );

}
